import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../Logo/Logo";
import { Icon } from "../Icon/Icon";

export const Header = ({ customClasses, iconNameLeft }) => {
  const navigate = useNavigate();

  return (
    <header className={["header-main", customClasses].join(" ")}>
      <div className="container">
        {iconNameLeft && (
          <a
            href=""
            onClick={(evt) => {
              evt.preventDefault();
              navigate(-1);
            }}
            className="header-left"
            target="_blank"
          >
            <Icon setViewBox="yes" name={iconNameLeft} />
          </a>
        )}
        <Logo />
      </div>
    </header>
  );
};
